// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"125f7a14","164":"2052cc5c","243":"0a697e3c","288":"6e7be712","300":"efe3b4a4","303":"4e1728c1","330":"c8a41b61","467":"5e4496e9","480":"8163098f","485":"33b3dde4","527":"dc5e64b1","594":"e2c3f17e","827":"8fa8be0b","879":"a0e92199","974":"9325d626"}[chunkId] + ".chunk.js";
};